// --------------------------------------------------------------
// Texts
// --------------------------------------------------------------

import {
  SCENE_1,
  SCENE_2,
  SCENE_3,
  SCENE_4,
  SCENE_5,
  SCENE_FADE_TIME,
  SCENE_HALF_VISIBLE_TIME,
  SCENE_LENGTH,
  WALK_END,
  WALK_START,
} from './positions';

export const TEXT = {
  // 0
  T_0_0:
    'Klíček od této skříňky nosila na řetízku na krku. Tušil jsem, že v ní budou písemnosti, psávala je po nocích s ještě větší vervou a zanícením než svoje knihy. Po její smrti je teď pročítám a cvikr mám zarosený slzami. Věřte mi, není to laciný sentiment po štamprli rosolky.',
  T_0_1:
    'Bylo mi dvanáct, třináct let, na tu dobu nejraději vzpomínám. Tělo moje už rozvité, přece ale ještě napůl panna, napůl děcko, nebylo plné, okrouhlé, ještě jsem se nestyděla vylézt před chlapci na strom, anebo když jsem šla ze školy, vyzdvihnout sukně nad kolena a brodit se vodou, ani mi nepřekáželo sednout obkročmo na koně a projíždět se po louce. Nejmilejší moje fantazie byla jít do kláštera, a to jen proto, že se jeptišky učí jako studenti a to byla by moje radost bývala – knihy.',
  T_0_2:
    'Radost a prokletí jejího života. O Chvalkovicích jsem věděl útržkovitě, že ji sem dali na vychování do rodiny správce panství Augustina Hocha. Dodneška je tu obrovská zámecká knihovna. Co svazek, to nové dobrodružství zašifrované do písmen. Škoda, že se o tom dočítám až teď. Copak v dospělosti nezatoužila podívat se do kraje, který tak milovala? Mohli jsme sem zajet spolu na pár dní a třeba by se naše životy následně odvíjely jinak, ale co já vím?',

  // 1
  T_1_0:
    'Tenhle dopis mi poslala v roce 1857, po dvaceti letech manželství, do Korutan. Obdivuju ji, provdat se za muže o patnáct let staršího vyžaduje odvahu. Nemohlo ale být všechno tak zlé, jak píše. Čtyři děti se přece nenarodí z hořkosti a nenávisti.',
  T_1_1:
    'Kdybys byl ten rozum tehdáž míval, co nyní máš a mě tak znal, byl bys ze mě jinou ženu udělal. Já Tě měla ráda a na ideály svoje zapomněla. Stalo se jinak a trpěli jsme oba. Moje srdce bažilo být velmi milováno, mně bylo lásky zapotřebí jako květině rosa, ale darmo jsem hledala takovou, jakou já cítila. Já chtěla muže mít, před nímž bych se kořit mohla, jenž by vysoko nade mnou stál, já bych pro něj život obětovala, ale viděla jsem v mužích jen hrubé despoty. To zchladlo všecku vroucnost, úcta se ztratila a hořkost a vzdor v srdci se umístily.',

  // 2
  T_2_0:
    'Oni mluví česky, protože neumějí německy. A co mám říct o selském lidu! V jedné vesnici učí zedník, tu zase truhlář, který neumí ani pořádně číst a když chce, aby děti psaly, musí si dát předpis napsat. Ale anděl Páně nad ním bdí a nedá mu zahynout.',
  T_2_1:
    'Do Polné mě přeložili zanedlouho po svatbě. Ona se tam zpočátku na všechno dívala skrz prsty. Na candrbálu jsem ji seznámil s vlastenecky smýšlejícím starostou Antonínem Pittnerem a okruhem jeho přátel. Najednou už jí čeština nepřipadala jako humpolácký jazyk prosťáčků a začala česky i číst. Zejména Spisy Tylovy, jak sama napsala, jí hnuly srdcem. Naše okolí nám ale dalo najevo, že pro vlastenecké projevy nemá pochopení... Naštěstí mě brzy přeložili do Prahy.',

  // 3
  T_3_0:
    'Překládali mě z místa na místo, do čím dál odlehlejších zapadákovů, nicméně se mi podařilo rodinu usídlit natrvalo v Praze. Náš kvartýr nebyl nic honosného, nedostávalo se peněz na nájem, v zimě na uhlí do kamen, ale pokaždé se našel někdo, kdo pomohl, ať už Světlá, Podlipná nebo Purkyně. Tohle manželka napsala na škartku, kterou naše dcera Theodora donesla Josefu Václavu Fričovi:',
  T_3_1:
    'Prosím Vás, můžete-li, půjčte mi něco, a nezlobte se, já si nemohu pomoci; my byli ten měsíc bez toho živí hůř než žebráci. Jestli můj muž záhy nějakou službu nedostane, abychom mohli být živi jen poněkud pořádně, potom přestane všecko moje psaní. Já se obrátila již na všechny strany, odkud by mi mohli pomoct. To, co bych při nejpilnější práci literaturou vydělala, stačí leda na výživu, kdeže činže, oděv a vše ostatní?',

  // 4
  T_4_0:
    'Mužovi se nelíbí, že se tak zcela oddávám spisovatelství, raději by viděl, abych virtuózní hospodyní byla. Nahlížím, že bychom byli šťastnější. Dostala jsem od něj lampu, s takovým bílým sklem, není velká, ale elegantní. Večer, když sedím v pokoji, lampička mi pěkně svítí, při ruce šálek čaje, tu se mi staví před oči ty milé obrázky. Když pak odbije dvanáctá, a jedna, i druhá hodina, pak zhasnu, vlezu do postele a už ospalá myslím si: „Světe kuš!“',
  T_4_1:
    'Nakonec se přece jenom do kraje svého dětství vrátila. Neviděl jsem nikoho víc se radovat, než když rozbalila balíček z nakladatelství s prvním výtiskem Babičky.',

  // 5
  T_5_0:
    'Mnohé světlo mi zablesklo na cestě života, já myslela, že je to svit hvězdy, ale byla to jen bludička, která by mne do bahna zavedla. Pocítila jsem mnoho bolestí, trpkých klamů, byla jsem na pokraji zoufalství, avšak navzdor tomu neztratila jsem důvěru a lásku k lidem. Někdy ovšem vidím se nešťastnou, zbytečnou, takže bych s chladnou myslí odešla ze světa. Takové boje urvou kus života s sebou!',
  T_5_1:
    'Nemám sílu ani chuť číst dál. Zavírám skříňku a zase ji zamknu na klíček. Tohle je její skutečná rakev, ne ta na vyšehradském hřbitově.',
};

// --------------------------------------------------------------
// Settings
// --------------------------------------------------------------

export enum VerticalAlign {
  Top,
  Center,
  Bottom,
}

export enum HorizontalAlign {
  Left,
  Center,
  Right,
}

export interface TextSettings {
  letter: boolean;
  vertical: VerticalAlign;
  horizontal: HorizontalAlign;
  show: number;
  hide: number;
  continue: number;
  text: string;
  speech: string;
}

export const TEXT_SETTINGS: TextSettings[] = [
  // 0
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Center,
    show: 0,
    hide: SCENE_LENGTH * 2 * 0.333,
    continue: SCENE_LENGTH * 2 * 0.333,
    text: TEXT.T_0_0,
    speech: '0-0',
  },
  {
    letter: true,
    vertical: VerticalAlign.Top,
    horizontal: HorizontalAlign.Right,
    show: SCENE_LENGTH * 2 * 0.333,
    hide: SCENE_LENGTH * 2 * 0.666,
    continue: SCENE_LENGTH * 2 * 0.666,
    text: TEXT.T_0_1,
    speech: '0-1',
  },
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Center,
    show: SCENE_LENGTH * 2 * 0.666,
    hide: SCENE_LENGTH * 2,
    continue: SCENE_1.start + SCENE_FADE_TIME,
    text: TEXT.T_0_2,
    speech: '0-2',
  },

  // 1
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Left,
    show: SCENE_1.start + SCENE_FADE_TIME,
    hide: SCENE_1.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    continue: SCENE_1.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    text: TEXT.T_1_0,
    speech: '1-0',
  },
  {
    letter: true,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Right,
    show: SCENE_1.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    hide: SCENE_2.start,
    continue: SCENE_2.start + SCENE_FADE_TIME,
    text: TEXT.T_1_1,
    speech: '1-1',
  },

  // 2
  {
    letter: true,
    vertical: VerticalAlign.Top,
    horizontal: HorizontalAlign.Right,
    show: SCENE_2.start + SCENE_FADE_TIME,
    hide: SCENE_2.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    continue: SCENE_2.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    text: TEXT.T_2_0,
    speech: '2-0',
  },
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Center,
    show: SCENE_2.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    hide: SCENE_3.start,
    continue: SCENE_3.start + SCENE_FADE_TIME,
    text: TEXT.T_2_1,
    speech: '2-1',
  },

  // 3
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Right,
    show: SCENE_3.start + SCENE_FADE_TIME,
    hide: SCENE_3.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    continue: SCENE_3.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    text: TEXT.T_3_0,
    speech: '3-0',
  },
  {
    letter: true,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Left,
    show: SCENE_3.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    hide: SCENE_4.start,
    continue: SCENE_4.start + SCENE_FADE_TIME,
    text: TEXT.T_3_1,
    speech: '3-1',
  },

  // 4
  {
    letter: true,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Right,
    show: SCENE_4.start + SCENE_FADE_TIME,
    hide: SCENE_4.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    continue: SCENE_4.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    text: TEXT.T_4_0,
    speech: '4-0',
  },
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Left,
    show: SCENE_4.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    hide: SCENE_5.start,
    continue: SCENE_5.start + SCENE_FADE_TIME,
    text: TEXT.T_4_1,
    speech: '4-1',
  },

  // 5
  {
    letter: true,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Right,
    show: SCENE_5.start + SCENE_FADE_TIME,
    hide: SCENE_5.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    continue: SCENE_5.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    text: TEXT.T_5_0,
    speech: '5-0',
  },
  {
    letter: false,
    vertical: VerticalAlign.Bottom,
    horizontal: HorizontalAlign.Left,
    show: SCENE_5.start + SCENE_FADE_TIME + SCENE_HALF_VISIBLE_TIME,
    hide: WALK_START,
    continue: WALK_END,
    text: TEXT.T_5_1,
    speech: '5-1',
  },
];
